exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host {\n  /*\r\n  .btn-counting {\r\n    position: absolute;\r\n    right: 200px;\r\n    top: 10px;\r\n    z-index: 999;\r\n\r\n\r\n  }*/\n  /* .i-counting {\r\n    text-align: left;\r\n  }*/ }\n  :host .p-counting {\n    text-align: right;\n    font-size: 14px;\n    margin: 6% 0 0 -25%; }\n\n.style-capture-image {\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n  max-height: 600px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/trip2-theme/components/t2-template-basic/t2-template-basic.component.scss
// module id = 2155
// module chunks = 66